import { GET_VISITOR_BADGE_ACTION_TYPE, GET_VISITOR_DASHBOARD_ACTION_TYPE, GET_VISITOR_REGISTRATION_CREDENTIALS_ACTION_TYPE } from "../../../utils/constants";


const initialState = [];

function visitorDashboardReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_VISITOR_DASHBOARD_ACTION_TYPE:
            return [...state, payload];
        case GET_VISITOR_REGISTRATION_CREDENTIALS_ACTION_TYPE:
            return [...state, payload];
        case GET_VISITOR_BADGE_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default visitorDashboardReducer